var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoissons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 468.002 468.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 145.15,
    cy: 119.681,
    r: 92.001,
    fill: "#FFEB3B",
    opacity: 1,
    "data-original": "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M145.15 98.212a8 8 0 0 1-8-8V60.743a8 8 0 0 1 16 0v29.469a8 8 0 0 1-8 8zM119.4 112.903a7.963 7.963 0 0 1-3.976-1.063l-25.59-14.69A8 8 0 0 1 97.8 83.273l25.59 14.69c6.956 3.995 4.028 14.94-3.99 14.94zM93.825 157.15c-8.018 0-10.946-10.946-3.99-14.939l25.588-14.689a8 8 0 0 1 7.966 13.877l-25.588 14.689a7.962 7.962 0 0 1-3.976 1.062zM170.9 112.903c-8.018 0-10.946-10.945-3.99-14.939l25.59-14.69a8.002 8.002 0 0 1 7.966 13.877l-25.59 14.69a7.965 7.965 0 0 1-3.976 1.062z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BC34A",
    d: "M339.814 460.002H141.972v-.001a365.284 365.284 0 0 1-19.391-215.43l24.179-112.99h188.267l24.179 112.99a365.296 365.296 0 0 1-19.392 215.431z",
    opacity: 1,
    "data-original": "#8bc34a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#689F38",
    d: "m141.972 460.001 197.842.001v-.001a365.284 365.284 0 0 0 19.391-215.43l-9.836-45.967c-9.181 1.965-15.031 11-13.066 20.181l6.279 29.344c12.972 60.622 9.63 122.762-9.556 181.219-2.682 8.172-10.369 13.654-18.97 13.654l-146.326-.001c-8.6 0-16.288-5.482-18.97-13.654-19.186-58.457-22.528-120.597-9.556-181.218l5.186-24.235c1.965-9.181-3.885-18.217-13.066-20.181l-8.743 40.858a365.284 365.284 0 0 0 19.391 215.43z",
    opacity: 1,
    "data-original": "#689f38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M175.761 420.404a8.002 8.002 0 0 1-7.657-5.694c-15.746-52.277-18.006-108.241-6.536-161.844a8 8 0 1 1 15.646 3.348c-10.907 50.971-8.759 104.182 6.211 153.881 1.518 5.043-2.398 10.309-7.664 10.309z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m237.303 225.002 3.084 2.726c29.545 26.114 73.495 27.937 105.125 4.361l9.633-6.497-20.117-94.011H146.759l-19.866 92.835 1.506-.784c31.594-26.532 77.995-25.949 108.904 1.37z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M458.718 5.881a8 8 0 0 0-9.835-5.593L347.248 28.236a8.002 8.002 0 0 0-4.993 4.055l-46.962 91.289h-50.226c2.169-55.884-43.975-103.899-99.917-103.899-55.141 0-100.001 44.859-100.001 100 0 46.596 32.045 85.823 75.248 96.867l-5.638 26.35c-15.839 74.02-8.987 150.145 19.815 220.148a8 8 0 0 0 7.398 4.956h197.842a8.001 8.001 0 0 0 7.399-4.957c28.802-70.001 35.655-146.127 19.815-220.147L342.85 129.906a8.001 8.001 0 0 0-7.823-6.326h-21.741l41.59-80.848 98.25-27.017a7.998 7.998 0 0 0 5.592-9.834zm-397.569 113.8c0-46.317 37.683-84 84.001-84 47.223 0 86.097 40.732 83.9 87.899h-82.291a8.001 8.001 0 0 0-7.823 6.326l-15.186 70.968c-35.981-9.488-62.601-42.273-62.601-81.193zm290.234 126.564c14.787 69.105 8.912 140.127-16.97 205.757l-187.039-.001c-25.881-65.63-31.757-136.651-16.97-205.756l22.825-106.665h175.329z",
    opacity: 1,
    "data-original": "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#29B6F6",
    d: "m415.017 78.669 14.904 27.21 27.249 14.882-27.249 14.882-14.904 27.21-14.903-27.21-27.249-14.882 27.249-14.882z",
    opacity: 1,
    "data-original": "#29b6f6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6E6",
    d: "m50.154 356.971 14.903 27.211 27.249 14.882-27.249 14.882-14.903 27.21-14.904-27.21-27.249-14.882 27.249-14.882z",
    opacity: 1,
    "data-original": "#e8e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.939,
    cy: 382.058,
    fill: "#29B6F6",
    rx: 17.062,
    ry: 17.005,
    opacity: 1,
    "data-original": "#29b6f6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.092,
    cy: 27.681,
    fill: "#29B6F6",
    rx: 17.062,
    ry: 17.005,
    opacity: 1,
    "data-original": "#29b6f6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoissons);
export default __webpack_public_path__ + "static/media/Boissons.465e7906c29d2f07fb3250c2e9e075ed.svg";
export { ForwardRef as ReactComponent };